/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
export const AppConfigGen = {
  "APPAK": "web-9e16115b-2286-476d-8e7f-94aed2e076b3",
  "CLOUD_REGION": "ap-south-1",
  "COGNITO_USER_POOL": "ap-south-1_SYAvUpE7q",
  "COGNITO_USER_POOL_CLIENT_ID": "1be31hncbstgsosu8gib63k9g2",
  "COMPANY_NAME": "Zepnur Private Limited",
  "DEFAULT_COUNTRY": "IN",
  "DEFAULT_CURRENCY": "INR",
  "DEFAULT_ZONEINFO": "Asia/Kolkata",
  "ENDPOINT": "https://3o6i715f6c.execute-api.ap-south-1.amazonaws.com/Prod",
  "NAME": "ZEPNURhealth",
  "SUPPORT_EMAIL": "nidun.jacob@zepnur.com",
  "WEBAPP_LINK": "https://dt2yxcf9hl8xp.cloudfront.net"
}


// WEBPACK FOOTER //
// ./src/AppConfigGen.js